import React from "react";

const DELTA_BETTER = "#16a34a";
const DELTA_WORSE = "#dc2626";

function deltaColor(delta) {
  if (delta > 0.3) return DELTA_BETTER;
  if (delta < -0.3) return DELTA_WORSE;
  return "var(--v-text-2)";
}

function verdictColor(v) {
  if (v === "better") return DELTA_BETTER;
  if (v === "worse") return DELTA_WORSE;
  return "var(--v-text-2)";
}

export default function RefreshComparison({ data }) {
  if (!data) return null;
  const rows = data.dimensions || [];
  if (rows.length === 0 && !data.summary) return null;
  const hasScore = data.overall_improvement_score !== null && data.overall_improvement_score !== undefined;

  return (
    <div
      className="v-surface v-fade-in"
      data-testid="refresh-comparison-section"
      style={{ padding: 28, marginTop: 32, borderColor: "var(--v-accent)" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div className="overline">Refresh vs existing pack</div>
          <h3 style={{ marginTop: 6, fontSize: 24, letterSpacing: "-.01em" }}>What the refresh actually improves</h3>
        </div>
        {hasScore && (
          <div style={{ textAlign: "right" }}>
            <div className="overline">Improvement score</div>
            <div className="v-score" style={{ fontSize: 38 }}>
              {Number(data.overall_improvement_score || 0).toFixed(1)}
            </div>
          </div>
        )}
      </div>

      {data.summary && (
        <p style={{ marginTop: 14, color: "var(--v-text-2)", lineHeight: 1.6, maxWidth: 720 }}>
          {data.summary}
        </p>
      )}

      <div style={{ marginTop: 18, display: "grid", gap: 10 }} data-testid="refresh-comparison-rows">
        {rows.map((rd) => (
          <RefreshRow key={rd.key} rd={rd} />
        ))}
      </div>
    </div>
  );
}

function RefreshRow({ rd }) {
  const delta = Number(rd.improvement_delta || 0);
  const sign = delta > 0 ? "+" : "";
  return (
    <div
      data-testid={`refresh-row-${rd.key}`}
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 60px 12px 60px 56px 70px",
        alignItems: "center",
        gap: 12,
        padding: "10px 0",
        borderTop: "1px solid var(--v-border)",
      }}
    >
      <div>
        <div style={{ fontSize: 14, fontWeight: 500 }}>{rd.label || rd.key}</div>
        {rd.notes && (
          <div className="mono" style={{ fontSize: 11, color: "var(--v-text-2)", marginTop: 4, lineHeight: 1.5 }}>
            {rd.notes}
          </div>
        )}
      </div>
      <div className="mono" style={{ textAlign: "right", fontSize: 16, color: "var(--v-text-2)" }}>
        {Number(rd.prev_estimate || 0).toFixed(1)}
      </div>
      <div style={{ textAlign: "center", color: "var(--v-accent)" }}>→</div>
      <div className="v-score" style={{ textAlign: "right", fontSize: 20 }}>
        {Number(rd.new_score || 0).toFixed(1)}
      </div>
      <div style={{ textAlign: "right", fontSize: 14, fontWeight: 600, color: deltaColor(delta) }}>
        {sign}{delta.toFixed(1)}
      </div>
      <div style={{
        textAlign: "right", fontSize: 10, letterSpacing: ".12em", textTransform: "uppercase",
        fontWeight: 600, color: verdictColor(rd.verdict),
      }}>
        {(rd.verdict || "—").toUpperCase()}
      </div>
    </div>
  );
}
